const ERROR_CODES = {
  EMAIL_NOT_FOUND: 'Пользователь с таким email не найден',
  INVALID_PASSWORD: 'Неверный пароль',
  EMAIL_EXISTS: 'Пользователь с таким email уже существует',
  'Error: Network Error': 'Ошибка сети'
}

export function error(code) {
  console.log(code)
  return ERROR_CODES[code] ? ERROR_CODES[code] : `${code}`
}
